import classNames from 'classnames';
import Link from 'next/link';

import { useSession } from '../../../shared';
import IconUser from '../../components/icons/user.svg';
import { Button } from '../../components/button/button';
import accountStyles from '../account-overview.module.css';
import styles from './personal-info.module.css';

export const PersonalInfo = () => {
    const { user } = useSession();

    return (
        <header className={classNames(accountStyles['account__section'], styles['personal-info'])}>
            {user?.profile_image_thumbnail_url ? (
                <img src={user?.profile_image_thumbnail_url} alt="" className={styles['personal-info__avatar']} />
            ) : (
                <IconUser className={styles['personal-info__avatar']} />
            )}
            <div className={styles['personal-info__name-wrapper']}>
                <h2 className={styles['personal-info__name']}>{user?.full_name}</h2>
                <span className={styles['personal-info__email']}>{user?.email}</span>
                <span className={styles['personal-info__customer']}>Customer # {user?.id}</span>

            </div>
            <Link href="./personal-info" passHref>
                <Button className={styles['personal-info__button']} as="a">
                    Personal Info
                </Button>
            </Link>
        </header>
    );
};
